"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRouterDom = require("react-router-dom");
var _onEnterAggregateRouteHandler = _interopRequireDefault(require("./onEnterAggregateRouteHandler"));
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _default = exports["default"] = function _default(isServer, routes, location, store, replace, callback) {
  var emptyRouteMatchesCallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var allOnEnter = [];
  var allParams = {};
  var routeMatches = (0, _reactRouterDom.matchRoutes)(routes, location);
  if (!routeMatches) {
    if (emptyRouteMatchesCallback) {
      emptyRouteMatchesCallback();
    }
    return;
  }
  routeMatches.forEach(function (_ref) {
    var _ref$route = _ref.route,
      onServerEnter = _ref$route.onServerEnter,
      onEnter = _ref$route.onEnter,
      params = _ref.params;
    Object.assign(allParams, params);
    if (isServer && onServerEnter) {
      allOnEnter.push.apply(allOnEnter, _toConsumableArray(onServerEnter));
    }
    if (onEnter) {
      allOnEnter.push.apply(allOnEnter, _toConsumableArray(onEnter));
    }
  });
  (0, _onEnterAggregateRouteHandler["default"])(store, _constants.INTERNAL_ERROR_URI, allOnEnter)({
    location: location,
    params: allParams
  }, replace, function () {
    callback(Object.keys(allParams).includes('*') ? 404 : 200);
  });
};